import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import {Title} from 'react-admin'

const Settings = () => {
    return (
        <Card>
            <Title title="Настройки"/>

            <CardContent>
                Здесь могла быть ваша реклама
            </CardContent>
        </Card>
    )
}

export default Settings
